import type { UiMessages } from "../types";

export const ru: UiMessages = {
  nav: {
    streams: "Стримы",
    videos: "Видео",
    shorts: "Шортсы",
    forYou: "Для вас",
    vr: "VR",
    cartoon: "Мультики",
    hentai: "Хентай",
    sections: "Ещё",
    menu: "Меню",
    game: "Порно игра",
    stories: "Секс-рассказы",
    escorts: "Эскорт",
    ai: "AI-подруги",
    paysites: "Платные сайты",
    home: "Главная",
    following: "Подписки",
    watching: "История",
    rankings: "Рейтинг",
    invite: "Пригласить друзей",
    coins: "Sweet Coin",
    achievements: "Достижения",
    hot: "Горячее сейчас",
    random: "Случайное видео",
    saved: "Сохранённое",
    reacted: "Понравилось",
    boost: "Sweet Boost",
    premium: "Премиум",
    stars: "Порнозвёзды",
    productions: "Студии",
    categories: "Категории",
    telegram: "Telegram-канал",
    allSections: "Все разделы",
    mainNavigation: "Главное меню",
    quickNavigation: "Быстрая навигация",
    show: "Показать",
    coinsReady: "Можно забрать Sweet Coin",
    logIn: "Войти",
    search: "Поиск",
    closeSearch: "Закрыть поиск",
    language: "Язык",
    theme: "Тема",
    themeDark: "Тёмная",
    themeLight: "Светлая",
  },
  age: {
    parents: "Родителям: на странице «{link}» рассказано, как закрыть доступ к этому сайту. Sweet помечен меткой RTA.",
    parentalControls: "Родительский контроль",
    title: "Это сайт для взрослых",
    body: "Этот сайт содержит материалы с возрастными ограничениями, в том числе обнажённую натуру и откровенные сцены сексуального характера. Заходя на сайт, ты подтверждаешь, что тебе не меньше 18 лет или возраста совершеннолетия, установленного там, откуда ты заходишь на сайт, и что ты даёшь согласие на просмотр откровенных материалов сексуального характера.",
    enter: "Мне есть 18 — Войти",
    exit: "Мне нет 18 — Выйти",
  },
  consent: {
    title: "Файлы cookie",
    body: "Sweet бесплатен благодаря рекламе. Наши рекламные партнёры используют cookie, чтобы показывать её и считать просмотры и клики. Необходимые данные, например подтверждение возраста, сохраняются в любом случае.",
    privacy: "Политика конфиденциальности",
    acceptAll: "Принять все",
    onlyNecessary: "Только необходимые",
    settings: "Настройки cookie",
  },
  ago: { now: "сейчас", m: "{n} мин", h: "{n} ч", d: "{n} д", w: "{n} нед", mo: "{n} мес", y: "{n} г" },
  cams: {
    allPlatforms: "Все платформы",
    watchOnSite: "Смотреть на {site}",
    liveFor: "в эфире {time}",
    tryAnother: "Попробуй другой тег или регион или загляни чуть позже.",
    nobodyLiveOn: "Сейчас никого нет в эфире на {name}",
    platformShowUpHint: "Трансляции {name} появляются здесь, как только начинаются. Загляни чуть позже.",
    liveNowCount: "В эфире: {n}",
    opensOn: "открываются на {site}",
    streamerSite: "сайте трансляции",
    orWatch: "Или посмотри {link}.",
    videoTag: "видео #{tag}",
    liveStreams: "Прямые эфиры",
    platformStreams: "Прямые эфиры {name}",
    liveCams: "Веб-камеры онлайн",
    platformCams: "Веб-камеры {name}",
    moreLiveCams: "Ещё веб-камеры",
    byTopic: "Веб-камеры по темам",
    breadcrumb: "Навигационная цепочка",
    live: "В эфире",
    viewers: "Зрители:",
    isLive: "{name} в эфире",
    watchOn: "{title} — смотреть в прямом эфире на {site}",
    nobodyLive: "Сейчас никого нет в эфире",
    noMatch: "Нет трансляций по этим фильтрам",
    showUpHint: "Трансляции появляются здесь сразу, как только начинаются. Загляни чуть позже.",
    clearFilters: "Сбросить фильтры",
    clearAll: "Сбросить всё",
    clear: "Сбросить",
    seeAllPlatforms: "Все платформы",
    watchVideos: "Смотреть видео",
    onPlatform: " на {name}",
    newOnTelegram: "Новые веб-камеры в Telegram",
    loadMoreFailed: "Не удалось загрузить ещё — попробуй снова",
    platforms: "Платформы",
    streamPlatforms: "Платформы трансляций",
    platformsAndFilters: "Платформы и фильтры",
    categories: "Категории",
    all: "Все",
    region: "Регион",
    allRegions: "Все регионы",
    more: "Ещё",
    newModels: "Новые модели",
    tags: "Теги",
    removeTag: "Убрать тег",
    remove: "Убрать",
    loading: "Загрузка",
    offline: "Офлайн",
    seeAll: "Показать все",
    genders: { female: "Девушки", male: "Парни", couple: "Пары", trans: "Транс" },
    regions: { north_america: "Северная Америка", south_america: "Южная Америка", europe: "Европа и Россия", asia: "Азия", other: "Другие регионы" },
  },
  video: {
    fullScene: "Смотреть полную сцену на {site}",
    upNext: "Далее",
    nextPage: "Следующая страница",
    moreVideos: "Ещё видео",
    end: "Больше ничего нет.",
    loadMoreFailed: "Не удалось загрузить ещё — попробуй снова",
    likes: "Лайки",
    premiumVideo: "Премиум-видео",
    subscribeToWatch: "Оформи подписку, чтобы посмотреть это видео целиком.",
    getPremium: "Получить Премиум",
    logIn: "Войти",
    playsIn: "Воспроизводится в плеере {name}",
    partnerBlocked: "Видео идёт с серверов {name}, а они недоступны из вашей сети: возможно, {name} заблокирован вашим провайдером или в вашей стране.",
    unavailable: "{name} не показывает свои видео в твоей стране, поэтому это видео здесь посмотреть нельзя.",
    watchCams: "Смотреть веб-камеры",
    chatLive: "Живой чат с {name} на {site}",
    play: "Смотреть: {title}",
    sponsored: "Реклама",
    onlyfansCreators: "Модели OnlyFans",
    liveNowFree: "Сейчас в эфире · бесплатно",
    allVideos: "Все видео",
    stoppedAt: "Остановлено на {at} из {of}",
    watchedToEnd: "Просмотрено до конца",
  },
  profile: { followers: "Подписчики", views: "Просмотры", videos: "Видео", verified: "Проверено", follow: "Подписаться", unfollow: "Отписаться" },
  lists: {
    categories: "Категории",
    popular: "Популярные",
    aToZ: "А – Я",
    jumpToLetter: "Перейти к букве",
    allCategories: "Все категории",
    noVideosYet: "Здесь пока нет видео",
    pageN: "Страница {n}",
    newEveryDay: "Новые видео добавляются каждый день.",
    videoCount: "{n} видео",
    pornstars: "Порнозвёзды",
    pornstarsIntro: "Модели с самым большим числом подписчиков на этой неделе.",
    studios: "Порностудии",
    studiosIntro: "Студии и каналы — по числу подписчиков.",
    noVideosWithTag: "Нет видео с этим тегом",
    showAllVideos: "Показать все видео",
  },
  hot: {
    title: "Горячее сейчас",
    intro: "Видео, которые больше всего смотрят на Sweet в последние часы.",
  },
  comments: {
    title: "Комментарии",
    placeholder: "Напишите комментарий…",
    post: "Отправить",
    login: "Войдите, чтобы комментировать",
    coinsHint: "+{n} монет за каждый из первых {max} комментариев в день",
    earned: "+{n} монет",
    empty: "Комментариев пока нет. Будьте первым.",
    more: "Показать ещё",
    delete: "Удалить",
    short: "Напишите чуть больше.",
    long: "Слишком длинно: не больше {n} символов.",
    links: "Ссылки и контакты в комментариях запрещены.",
    forbidden: "Этот комментарий нельзя опубликовать.",
    rate: "Вы комментируете слишком часто. Попробуйте позже.",
    duplicate: "Вы уже это писали.",
    failed: "Не удалось отправить. Попробуйте ещё раз.",
    like: "Нравится",
    dislike: "Не нравится",
    rateLogin: "Войдите, чтобы оценивать видео",
    liked: "Нравится {p}%",
  },
  starVote: {
    title: "Звезда месяца",
    vote: "Голосовать",
    voteFor: "Проголосовать за {name} как за звезду месяца",
    voteAgain: "Ещё голос · {n} монет",
    confirm: "Потратить {n} монет?",
    standing: "№{rank} в этом месяце · голосов: {n}",
    noVotes: "В этом месяце ещё нет голосов",
    thanks: "Спасибо за голос!",
    paidThanks: "Голос учтён · −{n} монет",
    coins: "Не хватает монет: голос стоит {n}.",
    limit: "На сегодня голоса закончились.",
    rules: "Один бесплатный голос в день, дальше — {n} монет за голос.",
    boardIntro: "Участники голосуют за любимых звёзд на их страницах: один бесплатный голос в день, дополнительные — по {n} монет.",
    boardEmpty: "В этом месяце ещё нет голосов. Проголосуйте на странице звезды.",
    votes: "Голоса",
    lastWinner: "Звезда прошлого месяца",
    login: "Войдите, чтобы голосовать",
  },
  achievements: {
    title: "Достижения",
    intro: "Открывайте достижения, когда смотрите, подписываетесь и участвуете. За каждое — Sweet Coins.",
    unlocked: "Получено",
    coins: "+{n} монет",
    progress: "{x} из {n}",
    total: "Получено {x} из {n}",
    login: "Войдите, чтобы получать достижения и монеты за них.",
    signup: "Создать аккаунт",
    toast: "Новое достижение",
    names: {
      "videos-1": ["Первое видео", "Посмотрите первое видео"],
      "videos-10": ["Разогрев", "Посмотрите 10 видео"],
      "videos-100": ["Завсегдатай", "Посмотрите 100 видео"],
      "videos-1000": ["Знаток", "Посмотрите 1 000 видео"],
      "hours-1": ["Первый час", "Смотрите в сумме час"],
      "hours-10": ["Десять часов", "Смотрите в сумме 10 часов"],
      "hours-100": ["Марафон", "Смотрите в сумме 100 часов"],
      "streak-3": ["Три дня подряд", "Смотрите 3 дня подряд"],
      "streak-7": ["Неделя подряд", "Смотрите каждый день неделю"],
      "streak-30": ["Месяц подряд", "Смотрите каждый день 30 дней"],
      "follows-5": ["Фанат", "Подпишитесь на 5 звёзд или студий"],
      "likes-25": ["Большое сердце", "Лайкните 25 видео"],
      "saves-10": ["Коллекционер", "Сохраните 10 видео"],
      "days-7": ["Неделя монет", "Соберите монеты 7 дней"],
      "days-30": ["Месяц монет", "Соберите монеты 30 дней"],
      "invites-1": ["Приведи друга", "Пригласите друга, который зарегистрируется"],
      "comments-1": ["Первые слова", "Напишите первый комментарий"],
      "comments-25": ["Разговорчивый", "Напишите 25 комментариев"],
      "votes-1": ["Избиратель", "Проголосуйте за звезду месяца"],
    },
  },
  pwa: {
    appName: "Приложение Sweet",
    bannerLabel: "Установить приложение",
    bannerPitch: "Во весь экран, без магазина приложений",
    install: "Установить",
    notNow: "Не сейчас",
    installApp: "Установить приложение",
    howToInstall: "Как установить",
    inApp: "Вы в приложении.",
    cardPitch: "Во весь экран, в одно касание с экрана «Домой». Магазин приложений не нужен.",
    manual: "Откройте меню браузера и выберите {install} или {add}.",
    iosTitle: "Добавьте Sweet на экран «Домой»",
    iosShare: "Нажмите {share} в панели браузера (в iOS 26: {more}, затем {share})",
    iosAdd: "Выберите {add}",
    iosConfirm: "Нажмите {confirm}: Sweet откроется во весь экран с экрана «Домой»",
    share: "Поделиться",
    more: "•••",
    add: "На экран «Домой»",
    confirm: "Добавить",
    installMenu: "Установить приложение",
    gotIt: "Понятно",
    close: "Закрыть",
    offlineTitle: "Нет подключения",
    offlineBody: "Для видео и камер Sweet нужен интернет. Проверьте подключение и попробуйте снова.",
    retry: "Попробовать снова",
    recent: "Недавно открытые",
  },
  notifications: {
    title: "Уведомления",
    empty: "Пока ничего нового. Подпишитесь на звёзд и студии или добавьте вебкам-моделей в избранное — и их новости появятся здесь.",
    newVideos: "Новые видео",
    liveNow: "Сейчас в эфире",
    markRead: "Отметить всё прочитанным",
    pushOn: "Включить уведомления",
    pushOff: "Выключить уведомления",
    pushHint: "Узнавайте о новых видео и избранных моделях в эфире, даже когда Sweet закрыт.",
    pushBlocked: "Уведомления от Sweet запрещены в настройках браузера.",
    pushUnsupported: "Этот браузер не показывает уведомления. На iPhone сначала добавьте Sweet на экран «Домой».",
    pushEnabled: "Уведомления включены",
    favorites: "Избранные модели",
    addFavorite: "В избранное",
    removeFavorite: "Убрать из избранного",
    favoritesEmpty: "Пока нет избранных моделей. Нажмите на сердечко на вебкаме, чтобы добавить.",
    offline: "Не в эфире",
    viewAll: "Все",
  },
  forYou: {
    title: "Для вас",
    all: "Все",
    continueWatching: "Продолжить просмотр",
    intro: "Подобрано по тому, что вы лайкаете, сохраняете, смотрите и на кого подписаны.",
    empty: "Лайкните, сохраните или подпишитесь на несколько видео и звёзд — и здесь появятся видео, подобранные для вас.",
    more: "Ещё",
  },
  shorts: {
    straight: "Гетеро",
    gay: "Гей",
    trans: "Транс",
    watchFull: "Смотреть полностью",
    like: "Нравится",
    liked: "Понравилось",
    save: "Сохранить",
    saved: "Сохранено",
    share: "Поделиться",
    copied: "Ссылка скопирована",
    soundOn: "Включить звук",
    soundOff: "Выключить звук",
    tapForSound: "Нажмите, чтобы включить звук",
    report: "Пожаловаться",
    follow: "Подписаться",
    following: "Вы подписаны",
    previous: "Назад",
    next: "Дальше",
    close: "Закрыть",
    end: "Пока это всё. Ещё больше — в разделе «Видео».",
    empty: "Здесь пока нет шортсов.",
    live: "В эфире",
    watchLive: "Смотреть эфир бесплатно",
    watching: "{n} смотрят",
    profile: "Профиль",
    moreLive: "Ещё вебкам-эфиры",
  },
  search: {
    searches: "Запросы",
    popular: "Популярные запросы",
    categories: "Категории",
    searchFor: "Искать видео: «{q}»",
    nothingFor: "По запросу «{q}» ничего не найдено.",
    title: "Поиск по Sweet",
    placeholder: "Ищи видео, моделей и бренды",
    hint: "Находи видео, звёзд, студии и категории. Нажми / в любом месте, чтобы начать ввод.",
    stars: "Звёзды",
    productions: "Студии",
    other: "Другое",
    otherProfiles: "Другие профили",
    nothing: "Ничего не найдено",
    tryAgain: "Проверь написание или попробуй запрос пошире.",
    backHome: "На главную",
  },
  notFound: { title: "Такой страницы нет", body: "Возможно, видео удалено или в ссылке опечатка.", home: "На главную" },
  common: {
    close: "Закрыть",
    copy: "Копировать",
    copied: "Скопировано",
    more: "Ещё",
    loading: "Загрузка",
    clearAll: "Очистить всё",
    browseVideos: "Смотреть видео",
    scrollLeft: "Прокрутить влево",
    scrollRight: "Прокрутить вправо",
  },
  actions: {
    react: "Нравится",
    reacted: "Понравилось",
    save: "Сохранить",
    saved: "Сохранено",
    follow: "Подписаться",
    following: "Вы подписаны",
    followName: "Подписаться на {name}",
    unfollowName: "Отписаться от {name}",
    moreOptions: "Другие действия",
    share: "Поделиться",
    copyLink: "Копировать ссылку",
    linkCopied: "Ссылка скопирована",
    report: "Пожаловаться",
    home: "Sweet — на главную",
    onSweet: "{name} на Sweet",
    joinMe: "Присоединяйся ко мне на Sweet",
    inviteLink: "Ваша ссылка-приглашение",
  },
  library: {
    savedEmpty: "Пока ничего не сохранено",
    savedHint: "Нажмите на закладку под любым видео, чтобы сохранить его здесь. Список хранится только на этом устройстве.",
    reactedEmpty: "Пока нет лайков",
    reactedHint: "Видео с вашим сердечком появляются здесь, новые сверху.",
    watchingEmpty: "Вы ещё ничего не смотрели",
    watchingHint: "Видео, которые вы включали, появляются здесь с точным моментом, где вы остановились, и продолжаются с него, когда вы открываете их снова.",
    removeWatching: "Убрать из истории",
    removeVideo: "Убрать «{title}» из истории",
    followingEmpty: "Вы пока ни на кого не подписаны",
    followingHint: "Нажмите + у модели или студии — и их новые видео будут собираться здесь. Подписки хранятся только на этом устройстве.",
    discoverModels: "Найти моделей",
    noVideosHint: "Попробуйте другую категорию — новые видео добавляются каждый день.",
    backToAll: "Ко всем видео",
  },
  player: {
    resumesAt: "Продолжится с {at}",
    startOver: "Начать сначала",
    unavailable: "Это видео сейчас недоступно.",
    play: "Смотреть",
    pause: "Пауза",
    seek: "Перемотка",
    back10: "Назад на 10 секунд",
    forward10: "Вперёд на 10 секунд",
    mute: "Выключить звук",
    unmute: "Включить звук",
    volume: "Громкость",
    settings: "Настройки",
    pip: "Картинка в картинке",
    fullscreen: "Во весь экран",
    exitFullscreen: "Выйти из полноэкранного режима",
    quality: "Качество",
    speed: "Скорость",
    normal: "Обычная",
    auto: "Авто",
    partner: "партнёр",
  },
  ads: { ad: "Реклама", advertisement: "Реклама", muteAd: "Выключить звук рекламы", unmuteAd: "Включить звук рекламы", skipIn: "Пропуск через {n}", skipAd: "Пропустить ›" },
  auth: {
    username: "Имя пользователя",
    usernameOrEmail: "Имя пользователя или email",
    emailOptional: "Email (необязательно)",
    password: "Пароль",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmPassword: "Повторите пароль",
    confirmNewPassword: "Повторите новый пароль",
    showPassword: "Показать пароль",
    hidePassword: "Скрыть пароль",
    forgot: "Забыли пароль?",
    remember: "Не выходить из аккаунта",
    logIn: "Войти",
    createAccount: "Создать аккаунт",
    usernameHelp: "3–24 латинские буквы, цифры, точки или подчёркивания. Видно в рейтинге.",
    emailHelp: "Нужен только для сброса пароля. Его можно добавить позже в настройках аккаунта.",
    passwordHelp: "Не меньше 8 символов.",
    adult: "Мне 18 лет или больше.",
    agree: "Я принимаю {terms} и {privacy}.",
    terms: "условия использования",
    privacy: "политику конфиденциальности",
    savePhrasesTitle: "Сохраните фразы восстановления",
    savePhrasesBody: "Вы зарегистрировались без email, поэтому только эти фразы помогут вернуться в аккаунт, если вы забудете пароль.",
    continue: "Продолжить",
    resetHow: "Как сбросить пароль",
    byEmail: "Прислать ссылку на email",
    byPhrase: "Фраза восстановления",
    phraseIntro: "Для аккаунтов без email: введите имя пользователя и любую из фраз восстановления, которые вы сохранили при регистрации.",
    phrase: "Фраза восстановления",
    phrasePlaceholder: "слово слово слово слово",
    phraseHelp: "4 слова одной фразы. Каждая фраза срабатывает один раз.",
    saveNewPassword: "Сохранить новый пароль",
    sendLink: "Отправить ссылку для сброса",
  },
  phrases: {
    warning: "Сохраните их сейчас: больше они не появятся. Если вы забудете пароль, имя пользователя и любая из этих фраз позволят задать новый. Каждая фраза срабатывает один раз. Никому их не показывайте.",
    list: "Ваши фразы восстановления",
    copyAll: "Копировать все",
    download: "Скачать .txt",
    savedCheck: "Я сохранил(а) фразы восстановления в надёжном месте.",
    done: "Готово",
    fileTitle: "Фразы восстановления Sweet для @{username}",
    fileHow: "Если вы забудете пароль, откройте {url}, выберите «{option}» и введите имя пользователя и любую из этих фраз.",
    filePrivate: "Каждая фраза срабатывает один раз. Никому их не показывайте: любой, у кого есть ваше имя пользователя и одна из этих фраз, может завладеть аккаунтом.",
    none: "В вашем аккаунте нет ни email, ни фраз восстановления. Если вы забудете пароль, вернуться в аккаунт не получится. Создайте фразы восстановления прямо сейчас.",
    optional: "Фразы восстановления позволяют задать новый пароль без email. Пока у аккаунта есть email, они необязательны.",
    left: "Не использовано фраз: {left} из {total}.",
    leftMade: "Не использовано фраз: {left} из {total}, созданы {date}.",
    how: "Каждая вместе с именем пользователя один раз позволяет задать новый пароль. Потеряли их? Создайте новые — старые перестанут работать.",
    make: "Создать фразы восстановления",
    makeNew: "Создать новые фразы",
  },
  account: {
    menu: "Меню аккаунта",
    settings: "Настройки аккаунта",
    profiles: "Ваши профили",
    logOut: "Выйти",
    uploadPhoto: "Загрузить фото",
    removePhoto: "Удалить текущее фото",
    displayName: "Отображаемое имя",
    showInRankings: "Показывать меня в рейтинге",
    rankingsHelp: "Ваше имя, фото и статистика просмотров видны в публичном {link}. Выключите, чтобы не участвовать; ваше время всё равно считается.",
    save: "Сохранить",
    emailHelp: "Нужен только для ссылки на сброс пароля, если вы его забудете. Оставьте поле пустым, чтобы удалить email.",
    saveEmail: "Сохранить email",
    changePassword: "Сменить пароль",
    deleteWarning: "Аккаунт, сохранённые видео, лайки и подписки будут удалены навсегда. Отменить это нельзя.",
    typeToConfirm: "Введите {word} для подтверждения",
    deleteMine: "Удалить мой аккаунт",
  },
  pay: {
    billingPeriod: "Период оплаты",
    monthly: "Помесячно",
    yearly: "На год",
    yourPlan: "Ваш тариф",
    month: "месяц",
    year: "год",
    oneMonth: "1 месяц",
    months: "{n} мес.",
    oneYear: "1 год",
    years: "{n} г.",
    perMonth: "{price} в месяц",
    save: "Выгода {n}%",
    comingSoon: "Скоро",
    reward: "−{n}% — ваша награда",
    plays: "Игр в Sweet Room: {n}",
    addedAtOnce: "Начисляются сразу",
    get: "Получить {plan}",
    addMonth: "Продлить на месяц",
    addYear: "Продлить на год",
    opensSoon: "Оплата скоро откроется",
    alreadyMember: "Уже есть подписка?",
    choose: "Выберите способ оплаты",
    payWith: "Оплатить",
    starsInBot: "{n} Stars в нашем Telegram-боте",
    card: "Картой",
    crypto: "Криптовалютой",
    cryptoMore: "BTC, USDT, ETH, TON и ещё 30+",
    tooManyStars: "Слишком большая сумма для одного платежа в Telegram Stars.",
    cardMin: "Оплата картой — от {price}.",
    payStars: "Оплата в Telegram Stars",
    preparing: "Готовим оплату…",
    loginFirst: "Сначала войдите",
    cantStart: "Не удалось начать оплату",
    noAdsCoins: "Без рекламы + {n} Sweet Coins",
    addedOnPay: "Поступят на баланс сразу после оплаты",
    payInTelegram: "Оплатить в Telegram",
    waitingStars: "Ждём оплату — страница обновится сама",
    allSet: "Готово!",
    noAds: "Рекламы больше нет.",
    noAdsUntil: "Без рекламы до {date}.",
    coinsAdded: "{n} монет уже на балансе.",
    startWatching: "Смотреть",
    great: "Отлично",
    payCard: "Оплата картой",
    failedTitle: "Платёж не прошёл",
    failedBody: "Деньги не списаны. Можно попробовать ещё раз.",
    newTab: "Оплатите в новой вкладке",
    newTabBody: "Картой, Apple Pay или Google Pay на защищённой странице Chain2Pay. Эта страница обновится сама после оплаты.",
    waiting: "Ждём оплату…",
    openAgain: "Открыть страницу оплаты снова",
    somethingWrong: "Что-то пошло не так. Попробуйте через минуту.",
    offline: "Похоже, нет подключения к интернету. Попробуйте через минуту.",
    bestValue: "Выгоднее всего",
    coins: "монет",
    orStars: "или {n} Stars",
    packsSoon: "Пакеты монет совсем скоро появятся в продаже.",
    nCoins: "{n} Sweet Coins",
    collected: "+{n} Sweet Coins получено!",
    collectedToday: "Сегодня уже получено",
    nextBonus: "Следующий бонус через",
    collecting: "Получаем…",
    collect: "Забрать {n} Sweet Coins",
    alreadyCollected: "Сегодняшние монеты уже получены. Возвращайтесь завтра.",
    offerLabel: "Sweet Coins и Премиум",
    offerTitle: "Получите Sweet Coins",
    offerFor: "Для Sweet Room и платных видео",
    premiumFrom: "Премиум от {price}",
    upTo: "Без рекламы + до {n} монет",
    packsFrom: "Пакеты монет от {price}",
    collectFree: "Или забирайте бесплатные монеты каждый день",
    offerButton: "Предложение Sweet Coins",
    guestCollected: "+{n} Sweet Coins! Чтобы не потерять монеты, зарегистрируйтесь на Sweet.",
    guestKeep: "Без аккаунта монеты хранятся {days} дней, а потом сгорают.",
    guestSignup: "Зарегистрироваться бесплатно и сохранить",
    guestLogin: "Уже есть аккаунт? Войти",
    guestExpire: "{n} монет сгорят {date}.",
    guestUnsaved: "Монеты ещё не сохранены: зарегистрируйтесь, чтобы их не потерять",
    guestExpiring: "{n} ваших Sweet Coins сгорят меньше чем через сутки. Зарегистрируйтесь бесплатно, чтобы их сохранить.",
  },
  footer: {
    copyright: "Авторские права",
    takedown: "Удаление контента",
    contact: "Контакты",
    creators: "Авторам",
    claim: "Подтвердить профиль",
    webmasters: "Вебмастерам",
    terms: "Условия",
    privacy: "Конфиденциальность",
    info: "Информация о сайте",
    telegram: "{site} в Telegram",
  },
  report: {
    heading: "Пожаловаться на видео",
    reason: "Причина",
    takedown: "Авторские права / DMCA",
    abuse: "Я есть в этом видео без моего согласия",
    minor: "Кому-то в этом видео может быть меньше 18",
    other: "Другое",
    url: "Ссылка на видео или его ID",
    email: "Ваш email",
    details: "Подробности",
    detailsPlaceholder: "Что нужно удалить и почему?",
    send: "Отправить жалобу",
  },
};
